import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/Card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import downloadTemplate from '../../../utilities/downloadCsv';
import ToastNotification from '../../../components/Toast';
import Loader from '../../../components/partials/components/loader';
import { API_AGENTS_LIST, API_AGENT_DELETE, API_AGENT_BULK_LOGOUT, API_AGENT_BULK_UPLOAD } from '../../../service/url';
import { deleteApiCall, getApiCall, postApiCall, postApiMediaCall } from '../../../service/httpCall';
import exportData from '../../../utilities/export';
import '../../../assets/custom/css/custom.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import './slider.css'
import { Modal, Form, Button as BootstrapButton } from 'react-bootstrap';
import { EditIcon, DeleteIcon } from '../../../components/setting/elements';
import { UPLOAD_BULK_AGENT_CREATE, UPLOAD_BULK_AGENT_CREATE_REQUIREMENTS, UPLOAD_BULK_AGENT_CREATE_SAMPLE_DATE } from "../../../utilities/constant";
import InfoNote from "../../../components/InfoNote";
import { Dropdown} from 'react-bootstrap'
import { getUser } from "../../../utilities/setting";
import { MODULE_ACL,USER_ROLES } from '../../../utilities/constant';
import { toast } from 'react-toastify';


const Agents = () => {
   const navigate = useNavigate();
   const [agentList, setAgentList] = useState([]);
   const [loading, setLoading] = useState(false);
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [selectedAgents, setSelectedAgents] = useState([]);
   const [statusList, setStatusList] = useState({}); 
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [showBulkAddModal, setShowBulkAddModal] = useState(false); 
   const [bulkFile, setBulkFile] = useState(null); 
   const [showModal, setShowModal] = useState(false)
   const [newStatus, setNewStatus] = useState(false)
   const [agentId, setAgentId] = useState('')
   const [activeType, setActiveType] = useState('')
   const [types, setTypes] = useState([])
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)

   const getColumnsAndFilename = () => {
     const columns = UPLOAD_BULK_AGENT_CREATE;
     const requirements = UPLOAD_BULK_AGENT_CREATE_REQUIREMENTS;
     const sample_data = UPLOAD_BULK_AGENT_CREATE_SAMPLE_DATE;
     const filename = "Bulk_Create_Agents.csv";
     return { columns, requirements, filename, sample_data };
   };


   // useEffect(() => {
   //       if (toastProps) {
   //          setShowToast(true);
   //       }
   // }, [toastProps]);

   useEffect(() => {
      if (confirmDelete) {
         handleDeleteSelectedAgents();
      }
   }, [confirmDelete]);

   // Fetch Agents Data
   const fetchAgents = () => {
      setLoading(true);
      getApiCall(API_AGENTS_LIST)
         .then((resp) => {
            if (resp) {
               const updatedList = resp?.map((val) => ({
                  id: val.id,
                  agent_name: val.agent_name,
                  agent_number: val.agent_number,
                  is_allocated: val.is_allocated,
                  created_by: val.created_by?.username || 'Unknown',
                  created_at: new Date(val.created_at).toLocaleString(),
                  extension: val.extension?.map((ext) => ext.extension).join(', ') || 'N/A',
                  username: val.username,
                  type: val.type,
                  access: val.access,
                  email_id: val.email_id,
                  status: val.login_status === '1' ? 'Active' : 'Inactive',
                  agentTelephony: val.agentTelephony
               }));

               setAgentList(updatedList);

               // Initialize statusList
               setStatusList(
                  updatedList.reduce((acc, agent) => {
                     acc[agent.id] = agent.status === 'Active';
                     return acc;
                  }, {})
               );
            } else {
               // setToastProps({ type: 'danger', message: 'Failed to fetch agents' });
          toast.error("Failed to fetch agents");
            }
         })
         .catch((error) => {
            console.error('Fetch Error:', error);
            // setToastProps({ type: 'danger', message: 'Error fetching agents' });
          toast.error("Error fetching agents");
         })
         .finally(() => setLoading(false));
   };

   useEffect(() => {
      getUser().then((user) => {
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      });
      fetchAgents()
   }, []);


   useEffect(fetchAgents, []);

   const handleBulkAdd = () => {
      setShowBulkAddModal(true); // Open the modal
  };

  const handleCloseBulkAdd = () => {
   setShowBulkAddModal(false); // Close the modal
};

const handleBulkAddFileChange = (event) => {
   setBulkFile(event.target.files[0]); // Store the selected file
};


const handleBulkAddSave = async () => {
  if (!bulkFile) {
    toast.error("Please select a file to upload.");
    return;
  }

  // Validate file type
  const fileName = bulkFile.name.toLowerCase();
  if (!fileName.endsWith('.csv')) {
    toast.error("Invalid file type. Please upload a CSV file.");
    return;
  }

  const formData = new FormData();
  formData.append('file', bulkFile);

  try {
    const response = await postApiMediaCall(API_AGENT_BULK_UPLOAD, formData);

    // Normalize and extract success and failed data from possible nested backend responses
    const responseData = response?.data?.data || response?.data || response;
    const successRows = Array.isArray(responseData?.success) ? responseData.success : [];
    const failedRows = Array.isArray(responseData?.failed) ? responseData.failed : [];
    const successCount = successRows.length;
    const failedCount = failedRows.length;
    // For backwards compatibility with the rest of the code
    const failedList = failedRows;

    let failedMessage = "";
    if (failedCount > 0) {
    failedMessage = failedList
      .map((item, index) => `Row ${index + 1} → ${item.error}`)
      .join("\n");
  }

    if (successCount > 0 && failedCount === 0) {
      toast.success(`All ${successCount} agent(s) uploaded successfully!`);
    } 
    else if (successCount > 0 && failedCount > 0) {
      // Show only specific errors
      let errorDetails = `Successfully uploaded: ${successCount} agent(s)\nFailed: ${failedCount} row(s)\n\n`;
      
      if (failedRows && failedRows.length > 0) {
        failedRows.forEach((failedItem, index) => {
          const rowNumber = index + 1;
          const error = failedItem?.error || "Unknown error";
          errorDetails += `Row ${rowNumber}: ${error}\n`;
        });
      } else {
        errorDetails += "Some rows failed to upload.";
      }
      toast.error(`${successCount} agents uploaded successfully, ${failedCount} failed.\n\n${failedMessage}`);
    } 
    else {
      // All failed - show only specific errors
      let errorDetails = "";
      
      if (failedRows && failedRows.length > 0) {
        failedRows.forEach((failedItem, index) => {
          const rowNumber = index + 1;
          const error = failedItem?.error || failedItem?.message || "Unknown error";
          if (index > 0) errorDetails += "\n";
          errorDetails += `Row ${rowNumber}: ${error}`;
        });
      }
      
      // Ensure we always have an error message
      if (!errorDetails || errorDetails.trim() === "") {
        errorDetails = "Upload failed. Please check your file and try again.";
      }
      toast.error(errorDetails);
    }

    fetchAgents();
  } catch (error) {
    let errorMessage = "Failed to upload bulk agents";
    
    if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error?.message) {
      errorMessage = error.message;
    }
    toast.error(`${errorMessage}\n\nPlease ensure:\n- File is in CSV format\n- All required fields are present\n- Data format is correct\n- Download and use the template for reference`);
  } finally {
    setShowBulkAddModal(false);
    setBulkFile(null);
  }
};

  

   // Handle Status Toggle
   const handleStatusToggle = async (agentId, agentTelephony, type) => {
      const newStatus = !statusList[agentId];
      setNewStatus(newStatus)
      setAgentId(agentId)
      const types = agentTelephony?.map(item => item.type);
      setTypes(types)
      try {

         if (newStatus) {
            setShowModal(true)
         } else {
            const params = {
                type: type,
                login_status: newStatus ? '1' : '0'
            }
            await postApiCall(`/v2/agents/status/${agentId}`, params);
            // setToastProps({ type: 'success', message: `Logged Out From: ${type}` });
          toast.success(`Logged Out From: ${type}`);
            setShowToast(true);
            setActiveType('')
            fetchAgents();
         }
      } catch (error) {
         // setToastProps({ type: 'danger', message: `Error while Logged Out From: ${type}` });
          toast.error(`Error while Logged Out From: ${type}`);
         setShowToast(true);
      }
  };

    async function loginAs(type) {
        try {
            const params = {
                type: type,
                login_status: newStatus ? '1' : '0'
            }
            await postApiCall(`/v2/agents/status/${agentId}`, params);
            // setToastProps({ type: 'success', message: `Logged In as: ${type}` });
          toast.success(`Logged In as: ${type}`);
            setActiveType('')
            setShowToast(true);
            setShowModal(false)
            fetchAgents();
        } catch (error) {
            // setToastProps({ type: 'danger', message: error || `Error while Logged In as: ${type}` });
          toast.error(error || `Error while Logged In as: ${type}`);
            setShowToast(true);
        }
    }
  

   const handleDeleteSelectedAgents = () => {
      if (selectedAgents.length === 0) return;
      postApiCall(API_AGENT_DELETE, { agentIds: selectedAgents })
         .then((resp) => {
            // setToastProps({ type: 'success', message: 'Agents deleted successfully' });
          toast.success("Agents deleted successfully");
            fetchAgents();
            setSelectedAgents([]);
         })
         .catch((err) => {
            const errorMessage = err.toString().split(".")[0];
            // setToastProps({ type: 'danger', message: `Unable to delete agents: ${errorMessage}` });
           toast.error(`Unable to delete agents: ${errorMessage}`);
            fetchAgents();
            setSelectedAgents([]);
         })
         .finally(() => setEnableDeleteModal(false));
   };

   const handleAgentLogout = () => {
      if (selectedAgents.length === 0) return;
      postApiCall(API_AGENT_BULK_LOGOUT, { agentIds: selectedAgents })
         .then((resp) => {
          toast.success("Agents Logged Out successfully");
            fetchAgents();
            setSelectedAgents([]);
         })
         .catch((err) => {
            const errorMessage = err.toString().split(".")[0];
          toast.error(`Unable to LoggedOut agents: ${errorMessage}`);
            fetchAgents();
            setSelectedAgents([]);
         })
   };

   const handleExport = async () => {
      setButtonDisable(true);
      await exportData('Agent', setToastProps, setShowToast);
      setButtonDisable(false);
   };

   const onCheckboxChange = (e, agentId) => {
      const { checked } = e.target;
      setSelectedAgents((prevSelected) =>
         checked ? [...prevSelected, agentId] : prevSelected.filter((id) => id !== agentId)
      );
   };

   const onHeaderCheckboxChange = (e) => {
      const { checked } = e.target;
      if (checked) {
         const allAgentIds = agentList?.map((agent) => agent.id);
         setSelectedAgents(allAgentIds);
      } else {
         setSelectedAgents([]);
      }
   };

   const allocationStatusBodyTemplate = (rowData) => {
      return Number(rowData.is_allocated) === 0 ? 'Available' : 'Allocated';
   };

   const handleEditAgent = (agentId) => {
      navigate(`edit-agent/${agentId}`);
  };

     const handleDeleteSelectedAgent = (ids) => {
        setSelectedAgents(ids);
        setEnableDeleteModal(true)
     };

   return (
      <div style={{ marginTop: '20px' }}>
         <Row>
            <Col sm="12">
               <Card>
                  <Card.Header className="d-flex justify-content-between">
                     <h4>Agents List</h4>
                     <div>
                     <Button className="btn btn-primary me-2" onClick={handleBulkAdd}>Bulk Add</Button>
                     {(isSuperAdmin || loggedInUserACL[MODULE_ACL.AGENTS]?.add) && (
                        <Button className="btn btn-primary" onClick={() => navigate('/create-agent')}>Create Agent</Button>
                     )}
                     </div>
                     
                  </Card.Header>
                  <Card.Body className="px-0">
                     {loading ? <Loader /> : (
                        <>
                           <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                              {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.AGENTS]?.delete)) && (
                                 <Button
                                    label="Delete Selected"
                                    onClick={() => setEnableDeleteModal(true)}
                                    className="p-button-danger p-button-sm"
                                    style={{ marginLeft: '10px' }}
                                    disabled={selectedAgents.length === 0}
                                 />
                              )}
                              {agentList.length != 0 && <Button
                                 label="Export Data"
                                 onClick={handleExport}
                                 className="p-button-active p-button-sm"
                                 style={{ marginLeft: '10px' }}
                                 disabled={buttonDisable}
                              >
                                 {buttonDisable && (
                                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                 )}
                              </Button>}
                              <Button
                                 label="Bulk Logout"
                                 onClick={() => handleAgentLogout()}
                                 className="p-button-active p-button-sm"
                                 style={{ marginLeft: '10px' }}
                                 disabled={selectedAgents.length === 0}
                              />
                           </div>
                           <div className="scroll-container">
                           <DataTable value={agentList} paginator rows={10} emptyMessage="No agents found.">
                              <Column
                                 header={<Checkbox onChange={onHeaderCheckboxChange} checked={selectedAgents.length === agentList.length && agentList.length > 0} />}
                                 body={(rowData) => (
                                    <Checkbox
                                       onChange={(e) => onCheckboxChange(e, rowData.id)}
                                       checked={selectedAgents.includes(rowData.id)}
                                    />
                                 )}
                                 style={{ width: '3rem' }}
                              />
                              <Column field="agent_name" header="Agent Name" />
                              <Column field="agent_number" header="Agent Number" />
                              {/* <Column field="extension" header="Extensions" body={(rowData) => `${rowData.extension}`} /> */}
                              {/* <Column field="username" header="Username" /> */}
                              {/* <Column field="type" header="Type" /> */}
                              <Column field="access" header="Access" />
                              <Column field="email_id" header="Email ID" />
                              <Column field="created_by" header="Created By" />
                              <Column field="created_at" header="Joining Date" />
                              <Column body={allocationStatusBodyTemplate} header="Allocation Status" />
                              <Column
                              header="Status(Mobile/WEBRTC/Soft Phone)"
                              body={(rowData) => {
                                 // Find the active profile type
                                 const activeProfile = rowData.agentTelephony?.profile?.find(
                                    (p) => p.active_profile === true
                                 );
                                 const activeType = activeProfile?.type;
                                 const types = rowData?.agentTelephony?.profile?.map(item => item.type);

                                 return (
                                    <div style={{ textAlign: 'center' }}>
                                    {/* Toggle */}
                                    <label className="slider_switch">
                                       <input
                                          type="checkbox"
                                          checked={statusList[rowData.id] || false}
                                          onChange={() => handleStatusToggle(rowData.id, rowData.agentTelephony?.profile, activeType)}
                                       />
                                       <span className="slider"></span>
                                    </label>

                                    {/* Buttons */}
                                    <div
                                       style={{
                                          marginTop: '8px',
                                          display: 'flex',
                                          gap: '4px',
                                          justifyContent: 'center',
                                       }}
                                    >
                                       {types?.map((type) => (
                                          <button
                                          key={type}
                                          className={`btn btn-sm ${
                                             activeType === type ? 'btn-success' : 'btn-danger'
                                          }`}
                                          style={{ padding: '2px 6px', fontSize: '10px' }}
                                          >
                                          {type}
                                          </button>
                                       ))}
                                    </div>
                                    </div>
                                 );
                              }}
                              style={{ width: '10rem', textAlign: 'center' }}
                              />
                              <Column
                                 header="Actions"
                                 body={(rowData) => (
                                    <div className="actions" style={{ display: 'flex', gap: '5px' }}>
                                       {(isSuperAdmin || loggedInUserACL[MODULE_ACL.AGENTS]?.edit) && (
                                          <div onClick={() => handleEditAgent(rowData.id)}>
                                             <EditIcon title="Edit" />
                                          </div>
                                       )}

                                       {(isSuperAdmin || loggedInUserACL[MODULE_ACL.AGENTS]?.delete) && (
                                          <div>
                                             <DeleteIcon
                                                handleCallback={() => handleDeleteSelectedAgent([rowData.id])}
                                                title="Delete"
                                             />
                                          </div>
                                       )}

                                    </div>
                                 )}
                              />

                           </DataTable>
                           </div>
                        </>
                     )}
                  </Card.Body>
               </Card>
            </Col>
         </Row>

         <RenderDeleteModal
            show={enableDeleteModal}
            setShow={setEnableDeleteModal}
            setConfirmDelete={setConfirmDelete}
            isMultiDelete={true}
            clearSelectedData={() => setSelectedAgents([])}
            onConfirm={handleDeleteSelectedAgents}
         />


          <Modal show={showBulkAddModal} onHide={() => setShowBulkAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Upload Bulk Members</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formFile">
                            <Form.Label>Upload .csv File</Form.Label>
                            <Form.Control type="file" accept=".csv" onChange={handleBulkAddFileChange} />
                        </Form.Group>
                    </Form>
                    <InfoNote>
                      The details uploaded for each agent are also used to automatically create a corresponding user. The agent's name becomes the user's name, the username and password are used exactly as provided.
                      <br/><br/>
                      <strong>Required Fields:</strong> Agent Name, Agent Number, Email ID, Username, Password, Access, Type<br/>
                      <strong>Optional Fields:</strong> Extension ID, Description<br/>
                      <em>Please download the template to see the exact format and requirements.</em>
                    </InfoNote>
                    <Button variant="btn btn-primary btn-sm" onClick={(event) => {
                        const { columns, requirements, filename, sample_data } = getColumnsAndFilename();
                        downloadTemplate(event, columns, filename, requirements, sample_data);
                     }}>Download Template</Button>
                </Modal.Body>
                <Modal.Footer>
                    <BootstrapButton variant="secondary" onClick={() => setShowBulkAddModal(false)}>Close</BootstrapButton>
                    <BootstrapButton variant="primary" onClick={handleBulkAddSave}>Save</BootstrapButton>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="sm">
            <Modal.Header closeButton>
               <Modal.Title>Login as:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
               {['Soft Phone', 'Mobile', 'WEBRTC']?.map((type) => {
                  if (!types.includes(type)) return null;

                  const isActive = activeType === type;

                  return (
                  <div
                     key={type}
                     className="d-flex justify-content-between align-items-center"
                     style={{
                        width: '100%',
                        maxWidth: '300px',
                        padding: '6px 10px',
                        borderRadius: '6px',
                        border: '1px solid #ddd',
                        marginBottom: '10px',
                        background: '#f9f9f9',
                     }}
                  >
                     <div>
                        <b>{type}</b>
                     </div>

                     <label className="switch ms-3">
                        <input
                        type="checkbox"
                        checked={isActive}
                        onChange={() => loginAs(type)} 
                        />
                        <span className="slider"></span>
                     </label>
                  </div>
                  );
               })}
            </div>
            </Modal.Body>
            <Modal.Footer>
               <Button
                  label="Close"
                  className="p-button-secondary"
                  style={{ marginRight: '10px' }}
                  onClick={() => setShowModal(false)}
               />
            </Modal.Footer>
            </Modal>



            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
      </div>

      
   );
};

export default Agents;
